export type NavigatorExpansionStore = {
  read: (projectId: string) => ReadonlySet<string> | undefined;
  write: (projectId: string | undefined, ids: ReadonlySet<string>) => void;
  clear: () => void;
};

const createNavigatorExpansionStore = (): NavigatorExpansionStore => {
  const byProjectId = new Map<string, ReadonlySet<string>>();
  return {
    read: projectId => byProjectId.get(projectId),
    write: (projectId, ids) => {
      if (!projectId) return;
      if (ids.size === 0) byProjectId.delete(projectId);
      else byProjectId.set(projectId, ids);
    },
    clear: () => byProjectId.clear(),
  };
};

export const navigatorGroupExpansionStore = createNavigatorExpansionStore();
export const navigatorContractorExpansionStore = createNavigatorExpansionStore();

export const readNavigatorExpandedGroupIds = (projectId: string): ReadonlySet<string> | undefined => navigatorGroupExpansionStore.read(projectId);

export const writeNavigatorExpandedGroupIds = navigatorGroupExpansionStore.write;

export const readNavigatorExpandedContractorIds = (projectId: string): ReadonlySet<string> | undefined => navigatorContractorExpansionStore.read(projectId);

export const writeNavigatorExpandedContractorIds = navigatorContractorExpansionStore.write;

/**
 * Clears all in-memory expansion state. Wired into the app's `useClearCache`
 * (see State/useClearCache) so expansion is scrubbed at logout / impersonation /
 * org switch alongside every other cache, and used by tests to reset between
 * cases.
 */
export const clearNavigatorExpansionSessionCache = (): void => {
  navigatorGroupExpansionStore.clear();
  navigatorContractorExpansionStore.clear();
};
